import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import MD5 from "crypto-js/md5";
import { API_URL } from "../components/config"; // Adjust the import based on your project structure
import Swal from "sweetalert2"; // Import SweetAlert

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const fetchUserDetails = async () => {
    setLoading(true);
    try {
      const hashedPassword = MD5(password).toString();
      const response = await fetch(
        `${API_URL}/users/login/${email}/${hashedPassword}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const result = await response.json();
      if (response.ok && result.length > 0) {
        const user = result[0].userid;
        const role = result[0].role;
        const username = result[0].username;
        if (result[0].status === "active") {
          localStorage.setItem("adminId", user);
          localStorage.setItem("role", role);
          localStorage.setItem("userDetails", JSON.stringify(result[0]));
          localStorage.setItem("userName", username);
          navigate(role === "Human Resources" ? "/HrHome" : "/heatmap-ride-demand");
        }
      } else {
        const errorMessage =
          result.message || "Invalid credentials or user not found.";
        Swal.fire({
          icon: "error",
          title: "Login Failed",
          text: errorMessage,
        });
        console.error("Login error:", errorMessage); // Log error to console
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "An error occurred during login. Please try again.",
      });
      console.error("Error fetching user details:", error); // Log error to console
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    fetchUserDetails();
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#002966] to-[#001a4d] p-4">
      <div className="w-full max-w-md">
        <div className="bg-white rounded-2xl shadow-2xl p-8 space-y-8">
          <div className="text-center">
            <h1 className="text-3xl font-bold text-[#002966] mb-2">
              Welcome Back
            </h1>
            <p className="text-gray-500">Please sign in to your account</p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="space-y-2">
              <label className="text-sm font-medium text-gray-700 block">
                Email Address
              </label>
              <div className="relative">
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#ffc000] focus:border-transparent transition duration-200 outline-none"
                  placeholder="Enter your email"
                />
              </div>
            </div>

            <div className="space-y-2">
              <label className="text-sm font-medium text-gray-700 block">
                Password
              </label>
              <div className="relative">
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#ffc000] focus:border-transparent transition duration-200 outline-none"
                  placeholder="Enter your password"
                />
              </div>
            </div>

            <button
              type="submit"
              disabled={loading}
              className={`w-full py-3 px-4 rounded-lg text-white font-medium transition duration-200 
                ${
                  loading
                    ? "bg-gray-400 cursor-not-allowed"
                    : "bg-[#002966] hover:bg-[#001a4d] active:transform active:scale-95"
                }`}
            >
              {loading ? (
                <div className="flex items-center justify-center">
                  <div className="w-5 h-5 border-t-2 border-b-2 border-white rounded-full animate-spin mr-2"></div>
                  Signing In...
                </div>
              ) : (
                "Sign In"
              )}
            </button>
          </form>

          <div className="relative">
            <div className="absolute inset-0 flex items-center">
              <div className="w-full border-t border-gray-300"></div>
            </div>
            <div className="relative flex justify-center text-sm">
              <span className="px-2 bg-white text-gray-500">Need help?</span>
            </div>
          </div>

          <div className="text-center">
            <button className="text-[#002966] hover:text-[#ffc000] transition duration-200">
              Forgot Password?
            </button>
          </div>
        </div>

        <div className="mt-6 text-center text-sm text-gray-200">
          © 2026 Xgo. All rights reserved.
        </div>
      </div>
    </div>
  );
};

export default Login;
